module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    staticClass: "dataList colorList"
  }, [_c('div', {
    attrs: {
      "id": "colorSliderElement"
    }
  }, _vm._l((_vm.colors), function(item) {
    return (_vm.backgroundHasColor(item)) ? _c('div', {
      staticClass: "item hover-fade smooth pointer",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      class: {
        color: true
      },
      style: ({
        background: item.preview,
        border: item.border
      })
    }, [(_vm.currentColor.key == item.key) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e()])]) : _vm._e()
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cb47190!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Lists/ColorList.vue
// module id = 153
// module chunks = 0